import { components, paths } from "@api/api";
import useAxios from "@hooks/useFetch";
import { AISearchPage } from "@models/index";
import { useCallback } from "react";

const AI_PAGE_ENDPOINT: keyof paths = '/Ai/GetPage';
export type AiSearchPageResponseData = components["schemas"]["AiPageOutput"];

export type HomeAiSearchResponseModel = {
    data: AISearchPage | null;
    getPage: (query: string) => Promise<AISearchPage>;
    isLoading: boolean;
}

export function useAiSearchPage(): HomeAiSearchResponseModel {
    const {
        data,
        isLoading,
        doFetch
    } = useAxios<AiSearchPageResponseData>({
        method: 'get',
        url: AI_PAGE_ENDPOINT,
        lazy: true,
    });

    const getPage = useCallback(
        async (query: string) => {
            const response = await doFetch({ url: `${AI_PAGE_ENDPOINT}?query=${encodeURIComponent(query)}` });
            return response?.data?.page ?? 0;
        },
        [doFetch]
    );

    return {
        data: data?.page ?? null,
        getPage,
        isLoading,
    };

}